<template>
  <div class="vin-query-container">
    <!-- 渐变蒙层 - 覆盖在表单下方 成功或者失败才有蒙层-->
    <div v-if="!init" class="gradient-overlay"></div>
    
    <!-- 头部标题区域 -->
    <div class="header">
      <h1 class="main-title">{{ mainTitle }}</h1>
      <p class="sub-title">{{ subTitle }}</p>
    </div>

    <!-- 表单区域 - 在蒙层上面 -->
    <div class="form-wrapper" v-if="init">
        <label class="form-label">{{ form.formTitle }}</label>
        <el-input
          v-model="vinValue"
          type="text"
          class="form-input"
          :class="{ 'error': errorMessage }"
          :placeholder="form.placeholder"
          :maxlength="17"
          @input="clearError"
          :show-word-limit="true"
          clearable
        />
        <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
        <div class="form-hint">
          <span class="hint-icon" v-if="form.showHintPrefix">提示：</span>
          <template v-if="Array.isArray(form.hint)">
            <div v-for="(item, index) in form.hint" :key="index" class="hint-text">{{ item }}</div>
          </template>
          <span v-else class="hint-text">{{ form.hint }}</span>
        </div>
        <button
          class="query-btn"
          :class="{ 'btn-loading': loading }"
          :disabled="loading || !vinValue || vinValue.length < 17"
          @click="handleQuery"
        >
          {{ loading ? '查询中...' : form.buttonText }}
        </button>
    </div>

    <!-- 结果区域插槽 -->
    <!-- 如果父组件不传入插槽，子组件不会渲染任何内容 -->
    <slot name="SuccessContent"></slot>
    <slot name="FailContent"></slot>
     <!-- 备注区域 -->
    <div class="remark" v-if="init">{{ remark }}</div>
  </div>
</template>

<script>
export default {
  name: 'VinQuery',
  props: {
    mainTitle: {
      type: String,
      default: '车辆OTA升级查询'
    },
    subTitle: {
      type: String,
      default: '输入17位车架号，快速查询升级资格'
    },
    remark: {
      type: String,
      default: '温馨提示：系统数据每日同步，若查询结果有疑问可联系线下服务门店'
    },
    form: {
      type: Object,
      default: () => ({
        formTitle: '车辆车架号（VIN）',
        placeholder: '请输入17位车辆识别代码',
        hint: '1. 比亚迪App/小程序【我的-我的-车辆模型-车辆信息】长按复制；2. 通过行驶证、车辆前挡风玻璃左下角查看；',
        buttonText: '立即查询升级范围',
        showHintPrefix:true
      })
    },
    queryMethod: {
      type: Function,
      default: null
    },
     loading: {
      type: Boolean,
      default: false
    },
    successObj: {
      type: Object,
      default: () => ({})
    },
    init: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      vinValue: '',
      errorMessage: ''
    }
  },
  methods: {
    // 用户输入的时候会清除首位空格
    clearError() {
      this.errorMessage = ''
      this.vinValue = this.vinValue.trim()
    },
    handleQuery() {
      const vin = this.vinValue.trim().toUpperCase()
      const vinPattern = /^[A-Za-z0-9]{17}$/
      if (!vinPattern.test(vin)) {
        this.errorMessage = '车架号格式不正确，只能包含字母和数字'
        return
      }
       console.log('this.queryMethod', this.queryMethod,typeof this.queryMethod)
      if (this.queryMethod && typeof this.queryMethod === 'function') {
        console.log('进入查询')
        this.queryMethod(vin)
      } else {
        console.log('查询车架号:', vin)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import './common.less';


.vin-query-container {
  overflow: hidden;
  position: relative;
  .px2rem(padding-left, 24);
  .px2rem(padding-right, 24);
  box-sizing: border-box;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  min-height: 100vh;
  min-height: 100svh;
  min-height: 100dvh;
}

.gradient-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0;
  right: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.7);
}

.header {
  text-align: center;
  .px2rem(margin-top, 48);
  width: 100%;
  
  .main-title {
    .px2rem(font-size, 28);
    font-weight: 500;
    .px2rem(line-height, 36);
    color: #1a1d25;
    .px2rem(margin-bottom, 8);
    margin-top: 0;
  }
  
  .sub-title {
    .px2rem(font-size, 14);
    font-weight: 400;
    .px2rem(line-height, 22);
    color: #5c606a;
    margin-top: 0;
    margin-bottom: 0;
  }
}

.form-wrapper {
  .form-wrapper();
  box-sizing: border-box;
  .px2rem(padding-top, 16);
  .px2rem(padding-right, 16);
  .px2rem(padding-bottom, 24);
  .px2rem(padding-left, 16);
  
  .form-label {
    display: block;
    .px2rem(font-size, 14);
    font-weight: 500;
    .px2rem(line-height, 22);
    color: #1a1d25;
    .px2rem(margin-bottom, 8);
  }
}

.form-input {
  :deep(.el-input__inner) {
    width: 100%;
    .px2rem(height, 32);
    .px2rem(padding-top, 6);
    .px2rem(padding-right, 8);
    .px2rem(padding-bottom, 6);
    .px2rem(padding-left, 8);
    border: 0.5px solid #e9eaed;
    border-radius: 4px;
    .px2rem(font-size, 14);
    font-weight: 400;
    .px2rem(line-height, 22);
    color: #1a1d25;
    background: #ffffff;
    box-sizing: border-box;
    outline: none;
    transition: all 0.3s ease;
  }
  
  :deep(.el-input__count) {
    .px2rem(font-size, 14);
  }
  
  :deep(.el-input__clear) {
    .px2rem(font-size, 12);
  }
  
  &::placeholder {
    color: #c2c8d3;
  }
}

.error-message {
  .px2rem(font-size, 12);
  font-weight: 400;
  .px2rem(line-height, 16);
  color: red;
  .px2rem(margin-top, 8);
}

.form-hint {
  .px2rem(font-size, 12);
  font-weight: 400;
  .px2rem(line-height, 16);
  color: #9ba1af;
  .px2rem(margin-top, 8);
}

.hint-icon {
  font-weight: 400;
  color: #9ba1af;
}

.query-btn {
  width: 100%;
  .px2rem(height, 44);
  .px2rem(margin-top, 32);
  .px2rem(padding-top, 10);
  .px2rem(padding-right, 16);
  .px2rem(padding-bottom, 10);
  .px2rem(padding-left, 16);
  .px2rem( border-radius, 8);
  border: none;
  color: rgba(255, 255, 255, 1);
  background: rgba(26, 29, 37, 1);
  .px2rem(font-size, 14);
  font-weight: 500;
  .px2rem(line-height, 22);
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  transition: opacity 0.3s ease;

  &:disabled {
    cursor: not-allowed;
    background: rgba(26, 29, 37, 0.3);
  }

  &.btn-loading {
    cursor: not-allowed;
    background: rgba(26, 29, 37, 1);
    opacity: 1;
  }
}
// 尽量减少定位元素
.remark {
  .px2rem(font-size, 12);
  font-weight: 400;
  .px2rem(line-height, 16);
  color: #1a1d25;
  width: 100%;
  // form-wrapper和上面副标题的距离：138 - 66 - 48=24px
  // 24px+16px+form-wrapper的高度：24px+16px+219px=84px
  .px2rem(margin-top, 260);
}
</style>
